import { render, staticRenderFns } from "./cancelTrip-passenger.vue?vue&type=template&id=08b90f02&scoped=true&"
import script from "./cancelTrip-passenger.vue?vue&type=script&lang=js&"
export * from "./cancelTrip-passenger.vue?vue&type=script&lang=js&"
import style0 from "./cancelTrip-passenger.vue?vue&type=style&index=0&id=08b90f02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b90f02",
  null
  
)

export default component.exports